import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  DatesDurationInput,
  ProductDate,
  ProductDatesFilter
} from '../../lib/types/models/product/product-date'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getProductDates(input: PaginationRequest<ProductDatesFilter>) {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.products.getAllProductDates.url, null),
        input
      )
    )
    .get<PaginationResponse<ProductDate>>()
}

export const getDatesDuration = (input: DatesDurationInput) => {
  return restApiClient
    .url(
      encodeNestedObject<DatesDurationInput>(
        constructApiUrl(API.products.getDatesDuration.url, null),
        input
      )
    )
    .get<number>()
}
